export default "__VITE_ASSET__dHxBcNcS__"